/**
 * @generated SignedSource<<d75871b87e4b3a94da7a29b61b7e63e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoBlank = "blank" | "no" | "yes";
export type businessWorkLocationCheckQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessWorkLocationCheckQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly isWorkingAtRegisteredAddress: YesNoBlank | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessWorkLocationCheckQuery = {
  response: businessWorkLocationCheckQuery$data;
  variables: businessWorkLocationCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isWorkingAtRegisteredAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessWorkLocationCheckQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessWorkLocationCheckQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "49c24bf054a73fc4cadd1b656c8b0256",
    "id": null,
    "metadata": {},
    "name": "businessWorkLocationCheckQuery",
    "operationKind": "query",
    "text": "query businessWorkLocationCheckQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      isWorkingAtRegisteredAddress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3067613a098a02a97c8fcbac6055ca2";

export default node;
